import React from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";
import ServiceSection from "./ServiceSection";
import HomeSectionData from "./HomeSectionData";
import SecuritySection from "./SecuritySection";
import Section from "./Section";
import ClientTestimonialsSection from "./ClientTestimonialsSection";

const Home = () => {
  return (
    <div>
      <Helmet>
        {/* ================= BASIC SEO ================= */}
        <title>
          Seo Up Rank - AI Powered SEO Platform | Website Optimization & Site
          Audit Tool
        </title>

        <meta
          name="description"
          content="Seo Up Rank is an AI powered SEO platform that helps improve Google rankings with website optimization, keyword research, backlink analysis and advanced site audit tools."
        />

        <meta
          name="keywords"
          content="AI SEO tools, website optimization tool, SEO audit tool, keyword research tool, backlink checker, SEO ranking tool, SEO automation platform"
        />

        <meta name="robots" content="index, follow, max-image-preview:large" />
        <meta name="author" content="Seo Up Rank" />
        <meta name="language" content="English" />
        <meta name="revisit-after" content="7 days" />

        {/* ================= CANONICAL ================= */}
        <link rel="canonical" href="https://novarsis.ai/" />

        {/* ================= THEME ================= */}
        <meta name="theme-color" content="#008300" />

        {/* ================= OPEN GRAPH ================= */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Seo Up Rank - AI Powered SEO Platform"
        />
        <meta
          property="og:description"
          content="Optimize your website and improve search rankings using AI powered SEO tools and advanced site audits."
        />
        <meta property="og:url" content="https://novarsis.ai/" />
        <meta property="og:site_name" content="Seo Up Rank" />
        <meta
          property="og:image"
          content="https://novarsis.ai/seo-banner.png"
        />

        {/* ================= TWITTER SEO ================= */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Seo Up Rank - AI Powered SEO Platform"
        />
        <meta
          name="twitter:description"
          content="AI powered SEO tools for website optimization, keyword research and site audit."
        />
        <meta
          name="twitter:image"
          content="https://novarsis.ai/seo-banner.png"
        />

        {/* ================= GEO SEO ================= */}
        <meta name="geo.region" content="IN" />
        <meta name="geo.placename" content="India" />

        {/* ================= PERFORMANCE ================= */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />

        {/* ================= ORGANIZATION SCHEMA ================= */}
        <script type="application/ld+json">
          {`
          {
            "@context":"https://schema.org",
            "@type":"Organization",
            "name":"Seo Up Rank",
            "url":"https://novarsis.ai",
            "logo":"https://novarsis.ai/logo.png",
            "sameAs":[
              "https://facebook.com/seouprank",
              "https://linkedin.com/company/seouprank",
              "https://twitter.com/seouprank"
            ]
          }
          `}
        </script>

        {/* ================= WEBSITE SCHEMA ================= */}
        <script type="application/ld+json">
          {`
          {
            "@context":"https://schema.org",
            "@type":"WebSite",
            "name":"Seo Up Rank",
            "url":"https://novarsis.ai",
            "potentialAction":{
              "@type":"SearchAction",
              "target":"https://novarsis.ai/search?q={search_term_string}",
              "query-input":"required name=search_term_string"
            }
          }
          `}
        </script>

        {/* ================= SOFTWARE APPLICATION ================= */}
        <script type="application/ld+json">
          {`
          {
            "@context":"https://schema.org",
            "@type":"SoftwareApplication",
            "name":"Seo Up Rank",
            "applicationCategory":"SEO Tool",
            "operatingSystem":"Web",
            "description":"AI powered SEO platform for website optimization, keyword research and site audits.",
            "url":"https://novarsis.ai"
          }
          `}
        </script>

        {/* ================= BREADCRUMB SCHEMA ================= */}
        <script type="application/ld+json">
          {`
          {
            "@context":"https://schema.org",
            "@type":"BreadcrumbList",
            "itemListElement":[
              {
                "@type":"ListItem",
                "position":1,
                "name":"Home",
                "item":"https://novarsis.ai"
              }
            ]
          }
          `}
        </script>
      </Helmet>

      {/* ================= PAGE SECTIONS ================= */}
      <h1 className="sr-only">Seo Up Rank AI Powered SEO Platform</h1>

      <HeroSection />

      <h2 className="sr-only">SEO Services and Optimization Tools</h2>

      <ServiceSection />

      <h2 className="sr-only">SEO Platform Features and Data Analysis</h2>

      <HomeSectionData />

      <h2 className="sr-only">Website Security and Protection</h2>

      <SecuritySection />

      <h2 className="sr-only">SEO Tools and Platform Benefits</h2>

      <Section />

      <h2 className="sr-only">Customer Reviews and Testimonials</h2>

      <ClientTestimonialsSection />
    </div>
  );
};

export default Home;
